import api from './api';

// Simple in-memory cache to avoid duplicate whoami calls across components
let cachedUser = null;
let inflight = null;

export const fetchCurrentUser = async (force = false) => {
  try {
    if (!force && cachedUser) return cachedUser;
    if (!force && inflight) return await inflight;

    inflight = api.get('/auth/whoami')
      .then((response) => {
        cachedUser = response.data;
        return cachedUser;
      })
      .finally(() => {
        inflight = null;
      });

    return await inflight;
  } catch (error) {
    console.error('Erreur lors de la récupération des informations de l\'utilisateur:', error);
    return null;
  }
};

// Fonction pour vider le cache utilisateur
export const clearUserCache = () => {
  cachedUser = null;
  inflight = null;
};
